import { gql } from '@apollo/client';

// checkout.com FULL FLOW migration. With Full Flow the SDK charges the card itself against the payment
// session, so the backend never sees `source.id` / `customer.id` in an HTTP response the way the old
// synchronous `createCardPayment` flow did — those only exist server-side and normally arrive via an
// ASYNCHRONOUS checkout.com webhook (seconds-to-minutes, and never on localhost). That delay means a
// saved card / MIT consent doesn't appear right after paying, and card-on-file can't be tested locally.
//
// `finalizePaymentSession` closes that gap: the SDK's `onPaymentCompleted` callback hands us the
// `pay_...` id the instant the charge succeeds, we pass it here, and the backend pulls the payment
// directly (`GET /payments/{id}`), reads `source.id` / `customer.id`, and runs the SAME storage logic
// the webhook would — within ~1s, and on localhost. The webhook remains the fallback.
export const FINALIZE_PAYMENT_SESSION = gql`
  mutation FinalizePaymentSession($finalizePaymentSession: FinalizePaymentSessionInput!) {
    finalizePaymentSession(finalizePaymentSession: $finalizePaymentSession) {
      status
      providerPaymentId
      referenceId
      errorMessage
    }
  }
`;
